export const baseUrl = 'https://trmstest.com'
export const baseReportUrl = 'https://trmstest.com'
